import ExcelJs from 'exceljs';

import { getLocalDateTime } from '@/utils/date';
import { generateExcelColumnNames, writeFileAndDownload } from '@/utils/excel';

import type { SpotBid } from '../types';

export const exportAuctionOrder = (
  columns: {
    name: string;
  }[],
  rows: (SpotBid[keyof SpotBid] | Date)[][],
) => {
  const sheetName = 'Auction Orders';
  const workbook = new ExcelJs.Workbook();
  const sheet = workbook.addWorksheet(sheetName, {});

  sheet.addTable({
    autoFilterEnabled: true,
    columns,
    headerRow: true,
    name: 'Header',
    ref: 'A1',
    rows,
    style: {
      showRowStripes: false,
      // @ts-expect-error
      theme: '',
    },
    totalsRow: false,
  });

  sheet.views = [
    {
      activeCell: 'A1',
      state: 'frozen',
      xSplit: 1,
    },
  ];
  const columnsList = generateExcelColumnNames(columns.length);

  columnsList.forEach((column) => {
    const cell = sheet.getCell(`${column}1`);
    cell.fill = {
      fgColor: { argb: '75A72E' },
      pattern: 'solid',
      type: 'pattern',
    };
    cell.font = {
      // @ts-expect-error
      bold: 700,
      color: { argb: 'FFFFFF' },
      size: 10,
    };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  });
  sheet.columns = sheet.columns.map((_e) => ({ width: 30 }));

  workbook.xlsx.writeBuffer().then((buffer) => {
    writeFileAndDownload(`Auction_Order_List ${getLocalDateTime().toLocaleDateString()}`, buffer);
  });
};
